import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import FeatureList from './FeatureList';
import MainContentLayout from '../../../components/Layout/MainContentLayout';

const Feature = () => {
    const menuDispatch = useDispatch();
    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'features'
        });
    }, []);
    return (
        <>
            <FeatureList/>            
        </>
    )
}

export default Feature;
